/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../utils';
import AOForm from '../../../shared/AOForm';

class AccountQuestionForm extends Component {

    handleQuestion = (question, isQuestionStatus) => {
        const { selectedLanguage, onChangeAnswerForm, errorList, errorMsgs, isYesNo, i18n } = this.props;
        const { 
            questionLocales,
            answerType,
            answers,
            userAnswer,
            hintLocales,
            questionId,
            hintStyle,
            questionIndicator
        } = question;
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        const questionMarkDetail = (hintStyle=== "{\"style\":0}") && getContentByLocal(hintLocales, selectedLanguage);
        const questionTip = (hintStyle=== "{\"style\":1}") && getContentByLocal(hintLocales, selectedLanguage);
        let errorMsg = errorMsgs[questionId];
        let isError = errorList.indexOf(questionId) !== -1;
        let defaultValue = null;
        switch (answerType) {
            case 1: 
                const radioItems = answers && answers.map( answer => {
                    return {
                        'dataIndex': answer.index,
                        'value': answer.answerId,
                        'dataKey': answer.answerIndicator,
                        'display': getContentByLocal(answer.answerLocales, selectedLanguage)
                    }
                });
                if (userAnswer) {
                    defaultValue = userAnswer.chosenAnswerId
                }
                if (isQuestionStatus && userAnswer && (questionId === 'Q002-002' || questionId === 'Q002-003' || questionId === 'Q002-008')) {
                    const showTipsId = isYesNo[questionId] ? '001' : '002';
                    const TipsDefaultValue = defaultValue && defaultValue.split(':')[1];
                    if (TipsDefaultValue !== showTipsId) {
                        isError = true;
                        errorMsg = i18n.tipsErrorMsg;
                    }
                }
                let radioArrays = {
                    question:{
                        title: questionTitle,
                        dataKey: questionIndicator
                    },
                    radioName: questionId,
                    defaultValue: defaultValue,
                    radioItems: radioItems,
                    questionRel: question,
                    dataLabel: `radio-${questionId}`,
                    isError: isError,
                    errorMessage: errorMsg
                };
                if (questionMarkDetail) {
                    radioArrays = {
                        ...radioArrays,
                        questionMark: {
                            hints: questionMarkDetail,
                            dataKey: `${questionIndicator}-questionMark`
                        }
                    }
                }
                if (questionTip) {
                    radioArrays = {
                        ...radioArrays,
                        questionTip: {
                            title: questionTip
                        }
                    }
                }
                return <AOForm.RadioButton
                    handleRadioChange={ onChangeAnswerForm }
                    content={radioArrays}
                />;
            default:
                return null;
        }
    }
    render () {
        const {
            formResult,
            dataId,
            isQuestionStatus,
            isApplicable
        } = this.props;
       return (
            <div className="account-list" data-id={dataId}>
                {
                    formResult && formResult.questions && formResult.questions.map((item, index) => {
                        const { questionId } = item;
                        if (isApplicable && (questionId === 'Q002-001' || questionId === 'Q002-002' || questionId === 'Q002-005')) {
                            return null;
                        } else {
                            return (
                                <div className="clearfix account-form" key={index}>
                                    {/*<div className="num">{index+1}.</div>*/}
                                    {this.handleQuestion(item, isQuestionStatus)}
                                </div>
                            )
                        }
                        
                    })
                }
            </div>
        );
    }
}

AccountQuestionForm.propType = {
    dataId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tip: PropTypes.string.isRequired

};
export default AccountQuestionForm;


// WEBPACK FOOTER //
// ./src/views/AccountQuestion/components/AccountQuestionForm.js